export const INCOMPLETE_PARSE = 'Incomplete parse.';
export const SYNTAX_ERROR = 'Syntax error at';
